import Icon from '../Icon';
function NavSearch() {
  return (
    <form className='relative w-full  block bg-white rounded-[1.5rem] shadow-2xl'>
      <Icon
        name='search'
        className='w-5 absolute top-[50%] left-[3%] translate-y-[-50%] h-5 fill-greyPrimary'
      />
      <input
        type='text'
        className='py-2 px-10 block w-full font-Poppins placeholder:text-greyPrimary placeholder:font-Poppins text-greyPrimary rounded-[1.5rem] border border-greyLight outline-0 focus:border-greyPrimary'
        placeholder='Search'
      />
    </form>
  );
}

export default NavSearch;
